import React from 'react'
import { Box } from '@hanzo/ui'

import { holder } from '../holder'

const Copyright: React.FC<{
  className?: string
}> = ({
  className=''
}) => {

  const year = new Date().getFullYear()
  const yearString = (year > holder.since) ? `${holder.since} - ${year}` : holder.since.toString()

  return (
    <Box className={className}>
      {`Copyright © ${yearString}`}&nbsp;<br className='sm:hidden'/>{holder.name}.&nbsp;<br className='md:hidden'/>&nbsp;All rights reserved.
    </Box>
  )
}

export default Copyright
